import {apiClient} from '~/api/api-client';

type NiftApi = {
  email: string;
  referralCode: string;
};

type CallNiftResponse = {
  available: boolean;
  url: string;
};

export const callNift = async ({email, referralCode}: NiftApi): Promise<CallNiftResponse> => {
  let response: CallNiftResponse = {
    available: false,
    url: '',
  };

  if (!evite.features.isEnabled('nift', false)) {
    return response;
  }

  const resp = await apiClient.post(
    '/ajax/nift/nift-gift-available/',
    // biome-ignore lint/style/useNamingConvention: allow camel case
    {email, ...(referralCode && {referral_code: referralCode})},
    {headers: {'Content-Type': 'application/json'}}
  );

  if (resp.ok) {
    const body = await resp.json();
    response = {
      available: body.nift_gift_available,
      url: body.nift_affiliate_url,
    };
  }

  return response;
};
